import { useState, useEffect } from 'react';
import { collection, query, where, orderBy, limit, onSnapshot } from 'firebase/firestore';
import { db } from '../lib/firebase';
import { useAuth } from '../lib/auth-context';

const STORAGE_KEY_MATCHING = 'lastVisit_matching';
const STORAGE_KEY_ACTIVITIES = 'lastVisit_activities';
const SESSION_KEY_ACTIVITIES = 'sessionVisit_activities';

function getLastVisit(key: string): number {
  const val = localStorage.getItem(key);
  return val ? parseInt(val, 10) : 0;
}

export function markSectionVisited(section: 'matching' | 'activities') {
  const key = section === 'matching' ? STORAGE_KEY_MATCHING : STORAGE_KEY_ACTIVITIES;
  localStorage.setItem(key, Date.now().toString());
  if (section === 'activities') {
    sessionStorage.setItem(SESSION_KEY_ACTIVITIES, '1');
  }
}

export function useNewItems() {
  const { user } = useAuth();
  const [hasNewMatching, setHasNewMatching] = useState(false);
  const [hasNewActivities, setHasNewActivities] = useState(false);

  useEffect(() => {
    if (!user?.uid) {
      setHasNewMatching(false);
      setHasNewActivities(false);
      return;
    }

    const lastMatchingVisit = getLastVisit(STORAGE_KEY_MATCHING);
    const lastActivitiesVisit = getLastVisit(STORAGE_KEY_ACTIVITIES);

    const profilesRef = collection(db, 'travel_profiles');
    const profilesQuery = query(
      profilesRef,
      where('isActive', '==', true),
      orderBy('createdAt', 'desc'),
      limit(1)
    );

    const unsubProfiles = onSnapshot(profilesQuery, (snapshot) => {
      if (snapshot.empty) {
        setHasNewMatching(false);
        return;
      }
      const latest = snapshot.docs[0].data();
      const latestCreatedAt = latest.createdAt?.toMillis?.() || 0;
      setHasNewMatching(latestCreatedAt > lastMatchingVisit);
    }, () => setHasNewMatching(false));

    const activitiesVisitedThisSession = sessionStorage.getItem(SESSION_KEY_ACTIVITIES);
    setHasNewActivities(!activitiesVisitedThisSession);

    return () => {
      unsubProfiles();
    };
  }, [user?.uid]);

  return { hasNewMatching, hasNewActivities };
}
